module.exports = {"152522100":"别力古台镇","152522101":"洪格尔高勒镇","152522102":"查干淖尔镇","152522200":"那仁宝拉格苏木乡","152522201":"伊和高勒苏木乡乡","152522202":"吉尔嘎郎图苏木乡","152522203":"巴彦图嘎苏木","152522400":"玛尼图煤矿","152522401":"阿旗德力格尔工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/152522.json
// module id = 439
// module chunks = 0